var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoly201(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 169,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Lager 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "svg_1",
    fill: "#fff",
    points: "-8.2 181.38 185.3 181.38 185.3 6.75 -8.2 6.75 -8.2 181.38",
    className: "cls-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(37 82 84.5)",
    stroke: "null",
    id: "svg_2",
    clipPath: "url(#clip-path)",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "rotate(17 82 84.5)",
    stroke: "#000",
    id: "svg_3",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#fff",
    points: "24.714994430541992,84.51499938964844 68.48499298095703,144.72499084472656 139.2849884033203,121.71499633789062 139.2849884033203,47.28499221801758 68.48499298095703,24.274993896484375 24.714994430541992,84.51499938964844 ",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    transform: "rotate(17 82 84.5)",
    stroke: "#000",
    id: "svg_4",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    fill: "#fff",
    points: "29.274993896484375,84.45499420166016 70.01499938964844,140.55499267578125 135.98500061035156,119.13499450683594 135.98500061035156,49.774993896484375 70.01499938964844,28.35499382019043 29.274993896484375,84.45499420166016 ",
    className: "cls-3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoly201);
export default __webpack_public_path__ + "static/media/poly 2-01.c8be342f0153e0821e01c364e9d15990.svg";
export { ForwardRef as ReactComponent };